/**
 * @file automatically generated from MApp.Endpoints.FeatureAnalyzerController
 */

import { MetadataClient } from '../metadataClient';
import { ISaveAnalyzerView, IAnalyzerView, IAnalyzerViewListItem, IValidationResult, IAnalyzerVectorSet, IAnalyzerDataset, IAnalyzerLegend, IGeoServiceListItem, IAnalyzerBaseMap } from '../models';

export class FeatureAnalyzerClient extends MetadataClient {

	public static saveView(view: ISaveAnalyzerView) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(view),
				cache: 'no-cache'
			})
		);
	}

	public static uploadView(formData: FormData, viewName: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(viewName)}/upload`, {
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
		);
	}

	public static updateView(id: string, view: ISaveAnalyzerView) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(view),
				cache: 'no-cache'
			})
		);
	}

	public static getView(name: string) {
		return MetadataClient.ajax<IAnalyzerView>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getViewById(id: string) {
		return MetadataClient.ajax<IAnalyzerView>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static cloneView(id: string, newName: string) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache'
			})
		);
	}

	public static getViews() {
		return MetadataClient.ajax<IAnalyzerViewListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views`, {
				cache: 'no-cache'
			})
		);
	}

	public static deleteView(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache'
			})
		);
	}

	public static updateViewConfig(name: string, view: any[]) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}/configuration`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(view),
				cache: 'no-cache'
			})
		);
	}

	public static getViewConfig(name: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}/configuration`, {
				cache: 'no-cache'
			})
		);
	}

	public static isValidView(name: string) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getPreview(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/preview`, {
				cache: 'no-cache'
			})
		);
	}

	public static getAttributeValues(id: string, attribute: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/values/${encodeURIComponent(attribute)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getValues(id: string, attributes: string[]) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/${encodeURIComponent(id)}/values`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				body: JSON.stringify(attributes),
				cache: 'no-cache'
			})
		);
	}

	public static getVectorSets() {
		return MetadataClient.ajax<IAnalyzerVectorSet[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/vectorsets`, {
				cache: 'no-cache'
			})
		);
	}

	public static getLiveDatasets() {
		return MetadataClient.ajax<IAnalyzerDataset[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/live`, {
				cache: 'no-cache'
			})
		);
	}

	public static getCachedDatasets() {
		return MetadataClient.ajax<IAnalyzerDataset[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/cached`, {
				cache: 'no-cache'
			})
		);
	}

	public static getLegends() {
		return MetadataClient.ajax<IAnalyzerLegend[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/featureanalyzer/legends`, {
				cache: 'no-cache'
			})
		);
	}

	public static getDatasetBounds(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/bounds`, {
				cache: 'no-cache'
			})
		);
	}

	public static getVectorSet(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/vectorsets/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getBaseMaps() {
		return MetadataClient.ajax<IGeoServiceListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/basemaps`, {
				cache: 'no-cache'
			})
		);
	}

	public static getBaseMap(id: string) {
		return MetadataClient.ajax<IAnalyzerBaseMap>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/basemaps/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getMapViewStyleSet(id: string) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v4/featureanalyzer/mapViewStyle/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}
}
